import { pick } from 'lodash';
import { isEmpty } from 'lodash';
import { memoize } from 'lodash';

export const memoizePick = memoize((values, keys) => {
  let valuesPick = { ...values };
  if (!isEmpty(keys)) {
    valuesPick = pick(values, keys);
  }

  return valuesPick;
});
